import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TableContainer from '@mui/material/TableContainer';
import Pagination from '@mui/material/Pagination';

import moment from 'moment';
import 'moment/locale/ko';
import Container from '@mui/material/Container';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 30, align: 'center' },
  { id: 'createdAt', label: '접속일자', minWidth: 150, align: 'center' },
  { id: 'pgm', label: '제품', minWidth: 180, align: 'center' },
  { id: 'ver', label: '버전', minWidth: 100, align: 'center' },
  { id: 'cpname', label: '회사', minWidth: 180, align: 'center' },
  { id: 'partname', label: '부서', minWidth: 180, align: 'center' },
  { id: 'username', label: '사용자', minWidth: 100, align: 'center' },
  { id: 'keycode', label: '활성화 코드', minWidth: 100, align: 'center' },
  { id: 'dueDate', label: '만료일', minWidth: 100, align: 'center' },
  { id: 'issueSite', label: '발급처', minWidth: 100, align: 'center' },
  { id: 'isAble', label: '활성화여부', minWidth: 100, align: 'center' }
];

export default function LogMng() {
  const [srchData, setSrchData] = useState({ isDohwa: true, isResearcher: true, isAgent: true, isDAC: false, isBlock: false });
  const [datas, setDatas] = useState({});
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const handleChangeSrch = (e) => {
    setSrchData({ ...srchData, [e.target.id]: e.target.value });
  };

  const handleChangeCheckbox = (e) => {
    setSrchData({ ...srchData, [e.target.name]: e.target.checked });
  };

  // const handleChange = e => {
  //     setDatas({ ...datas, [e.target.id]: e.target.value });
  // }

  const handleRowClick = (data) => (evt) => {
    setDatas(data);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  /**
   * 로그관리 > 데이터 조회
   * @param {*} e
   */
  const getDataList = async (e) => {
    const { search, isDohwa, isResearcher, isAgent, isDAC, isBlock } = srchData;
    let params = { search, isDohwa, isResearcher, isAgent, isDAC, isBlock, offset, page, limit: offset };

    const response = await axios.get(`/api/log`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  /**
   * 로그관리 > 내용 초기화
   * @param {*} evt
   */
  const onClickInit = (evt) => {
    setDatas({});
  };

  /**
   * 로그관리 > 신규등록
   * @param {*} evt
   */
  const onClickSave = async (evt) => {
    const { userid, username, userpw } = datas;
    let params = { userid, username, userpw };

    try {
      const response = await axios.post(`/api/log`, params);
      getDataList();
      onClickInit();
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  /**
   * 로그관리 > 기존데이터 수정
   * @param {*} evt
   */
  const onClickModify = async (evt) => {
    const { id, userid, username, isActive } = datas;
    let params = { userid, username, isActive };

    try {
      const response = await axios.patch(`/api/log/${id}`, params);
      getDataList();
      onClickInit();
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  /**
   * 로그관리 > 삭제
   * @param {*} evt
   */
  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        const response = await axios.delete(`/api/log/${datas.id}`);
        onClickInit();
        getDataList();
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      getDataList(page);
    }
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        로그 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <TextField id="search" variant="outlined" size="small" label="검색" value={srchData?.search || ''} onChange={handleChangeSrch} onKeyPress={handleKeyPress} />
            <FormControlLabel control={<Checkbox />} id="isDohwa" name="isDohwa" label="도화 제외" onChange={handleChangeCheckbox} checked={srchData.isDohwa} />
            <FormControlLabel control={<Checkbox />} id="isResearcher" name="isResearcher" label="도화연구원 제외" onChange={handleChangeCheckbox} checked={srchData.isResearcher} />
            <FormControlLabel control={<Checkbox />} id="isAgent" name="isAgent" label="Agent 제외" onChange={handleChangeCheckbox} checked={srchData.isAgent} />
            <FormControlLabel control={<Checkbox />} id="isDAC" name="isDAC" label="DIDAS 발급" onChange={handleChangeCheckbox} checked={srchData.isDAC} />
            <FormControlLabel control={<Checkbox />} id="isBlock" name="isBlock" label="차단 제외" onChange={handleChangeCheckbox} checked={srchData.isBlock} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      if (col.id === 'issueSite') {
                        let issueSite = 'DIDAS';
                        if (row.ActiveCodeMng) {
                          issueSite = 'DAC';
                        } else if (!row.keycode) {
                          issueSite = 'NONE';
                        }
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {issueSite}
                          </TableCell>
                        );
                      } else if (col.id === 'isAble') {
                        if (row.DisabledActiveCode) {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              차단
                            </TableCell>
                          );
                        } else {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              활성화
                            </TableCell>
                          );
                        }
                      }
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {col.id === 'createdAt' ? moment(row[col.id]).format('YYYY-MM-DD HH:mm:ss') : row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
    </Paper>
  );
}
